var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{attrs:{"id":"navigation"}},[_c('li',[_c('router-link',{staticClass:"link-menu",attrs:{"to":"/"}},[_c('b-icon',{attrs:{"icon":"map"}}),_vm._v(" "+_vm._s(_vm.$t('common.routes.countries')))],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }